import React from 'react';
import { Messages } from 'primereact/messages';
import Dropzone from 'react-dropzone';
import servicioAfil from '../servicios/ServicioAfil'
import { Button } from 'primereact/button';

export class SubirAfil extends React.Component {
  constructor() {
    super();
    this.state = {
      files: [],
      files2: [],
      archivos: [],
      ttCfdi: {},
      errores: []
    };
    this.guardar = this.guardar.bind(this);
  }
  onDrop = (files) => {
    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      var cfdi = files[i];
      formData.append('recibos', cfdi);
    }
    this.setState({ files2: formData });
    this.setState({ files });
  };
  guardar() {
    this.messages.clear();
    const { files2 } = this.state;
    servicioAfil.procesarAfil(files2).then((response) => {
      if (response.data.objeto.errores.length > 0) {

        for (var i = 0; i < response.data.objeto.errores.length; i++) {
          var valor = response.data.objeto.errores[i];
          this.messages.show({ severity: 'error', summary: 'Error', detail: valor, sticky: true });
        }
      }

      if (response.data.objeto.exitos.length > 0) {
        for (var i = 0; i < response.data.objeto.exitos.length; i++) {
          var valor = response.data.objeto.exitos[i];
          this.messages.show({ severity: 'success', summary: 'Éxito', detail: valor, sticky: true });
        }
      }


      this.setState({ files2: [] });
      this.setState({ files: [] });
    }).catch((error) => {

    });
  }
  render() {
    const files = this.state.files.length;
    return (
      <div className="content-section implementation">
        <div className="card card-w-title">

          <h1>Mi Afil</h1>
          <Messages ref={(el) => this.messages = el}></Messages>
          <br></br>
          <Dropzone accept=".pdf" onDrop={this.onDrop}>
            {({ getRootProps, getInputProps }) => (
              <section className="container">
                <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                  <input   {...getInputProps()} />
                  <center><p>Arrastra tus Archivos Afil aquí</p></center>
                </div>
                <br></br>
                <Button label="Guardar Afil" onClick={this.guardar} />
                <aside>
                  <h4>Cantidad de archivos a procesar</h4>
                  <ul>{files}</ul>
                </aside>

              </section>
            )}
          </Dropzone>
        </div>
      </div>
    )
  }

}